{
  "notifications": {
    "modalTitle": "Ustawienia powiadomień",
    "contactDetails": "Twoje dane kontaktowe",
    "notificationAbout": "Powiadomienie o",
    "email": "Adres e-mail",
    "phone": "Nr telefonu",
    "saveConfirm": "Zamierzasz zapisać zmiany. Czy chcesz kontynuować?",
    "saveSuccess": "Ustawienia powiadomień zostały zapisane.",
    "selectOrDeselectAll": "Zaznacz lub odznacz wszystkie",
    "options": {
      "email": "E-mail",
      "sms": "SMS"
    }
  }
}
